import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { Todo } from '@ninety/platform/models/todos/todo';
import { TodoDeleOptions } from '@ninety/platform/models/todos/todo-delete-options';
import { selectLanguage } from '@ninety/platform/state';
import { TerraRadioButtonModule } from '@ninety/terra';
import { StopPropagationDirective, ButtonComponent } from '@ninety/ui/core';

@Component({
  selector: 'ninety-repeat-todo-delete-dialog',
  templateUrl: './repeat-todo-delete-dialog.component.html',
  styleUrls: ['./repeat-todo-delete-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ButtonComponent,
    StopPropagationDirective,
    TerraRadioButtonModule,
  ],
})
export class RepeatTodoDeleteDialogComponent {
  readonly data = inject<{ todo: Todo }>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<RepeatTodoDeleteDialogComponent>>(MatDialogRef);
  private readonly store = inject(Store);

  TodoDeleOptions = TodoDeleOptions;
  protected deleteOption: TodoDeleOptions = TodoDeleOptions.item;

  readonly language$ = this.store.select(selectLanguage);

  delete(): void {
    this.dialogRef.close({ option: this.deleteOption, todo: this.data.todo });
  }
}
